import { api } from '@utils/ky.util';

export const sendUserSurvey = async (data) => {
  return await api
    .post('user-survey', {
      json: data,
    })
    .json();
};
